import { RETURN_TYPE_ROUTE } from "@redotech/redo-return-core-common/return";
import { ReturnTypeEnum } from "@redotech/redo-return-core-common/return-type-enum";
import {
  ClaimSystemView,
  RecycleSystemView,
  ReturnSystemView,
  WarrantySystemView,
  WithdrawalSystemView,
} from "@redotech/redo-return-operations-common/views/default-return-views";
import {
  AdvancedFilterData,
  encodeAdvancedFilterData,
} from "@redotech/redo-views-common/advanced-filters/advanced-filter-data";

/** The view that lists every record of a type, which each type's table opens by default. */
export const RECORD_ALL_VIEW: Record<ReturnTypeEnum, string> = {
  [ReturnTypeEnum.RETURN]: ReturnSystemView.ALL_RETURNS,
  [ReturnTypeEnum.CLAIM]: ClaimSystemView.ALL_CLAIMS,
  [ReturnTypeEnum.WARRANTY]: WarrantySystemView.ALL_WARRANTIES,
  [ReturnTypeEnum.RECYCLE]: RecycleSystemView.ALL_RECYCLE,
  [ReturnTypeEnum.WITHDRAWAL]: WithdrawalSystemView.ALL_WITHDRAWALS,
};

/**
 * Path of one type's table showing a view, relative to the merchant app's
 * `MerchantRoutesContext.returnsBaseUrl`.
 */
export function recordViewHref(
  returnsBaseUrl: string,
  type: ReturnTypeEnum,
  viewName: string,
): string {
  return `${returnsBaseUrl}/${RETURN_TYPE_ROUTE[type]}/${encodeURIComponent(viewName)}`;
}

/**
 * Path of one type's table with the filters and search text the table reads
 * from the URL, on the given view or on the type's all-records view.
 */
export function recordListHref(
  returnsBaseUrl: string,
  type: ReturnTypeEnum,
  {
    view = RECORD_ALL_VIEW[type],
    filters = [],
    search,
  }: { view?: string; filters?: AdvancedFilterData[]; search?: string } = {},
): string {
  const href = recordViewHref(returnsBaseUrl, type, view);
  const params = new URLSearchParams();
  if (filters.length > 0) {
    params.set("advancedFilters", encodeAdvancedFilterData(filters));
  }
  if (search) {
    params.set("search", search);
  }
  const query = params.toString();
  return query ? `${href}?${query}` : href;
}
